module.exports = __webpack_public_path__ + "static/popup_PC@1x-min-c212114344bf1b689928c68d2877d23d.png";